

const createdData = (formData, type, sale_rent, deleted,selectedStreets,) => {
  const result = {
    id: formData.get("id") || null,
    ...(type !== "land" && { sale_rent: sale_rent || null }),
    application_status: formData.get("application_status") || null,
    district: formData.getAll("district") || null,
    ...(type !== "land" && {
      building_type: formData.getAll("building_type") || null,
      building_status: formData.getAll("building_status") || null,
      rooms: formData.getAll("rooms") || null,
    }),
    ...(type === "land" && { propose: formData.getAll("propose") || null }),
    ...(type !== "land" && {
      bathrooms: formData.getAll("bathroom") || null,
      ceiling_height: formData.getAll("ceiling_height") || null,
    }),
    street: selectedStreets || null,
    ...(type === "land" && { land_number: formData.get("land_number") || null }),
    ...(type !== "land" && {
      min_building_floor: formData.get("minBFloor") || null,
      max_building_floor: formData.get("maxBFloor") || null,
    }),
    ...(type === "commercial" && {
      min_c_floor: formData.get("minFloor") || null,
      max_c_floor: formData.get("maxFloor") || null,
      commercial_type: formData.get("commercial_type") || null,
    }),
    ...(type === "house" && {
      building_number: formData.get("house_number") || null,
      min_land_surface: formData.get("min_land_surface") || null,
      max_land_surface: formData.get("max_land_surface") || null,
    }),
    ...(type === "apartment" && {
      min_a_floor: formData.get("minFloor") || null,
      max_a_floor: formData.get("maxFloor") || null,
    }),
    ...(type !== "land" &&
      type !== "house" && {
        building_number: formData.get("building_number") || null,
        room_number: formData.get("roomNumber") || null,
      }),
    min_surface: formData.get("minSqm") || null,
    max_surface: formData.get("maxSqm") || null,
    min_price: formData.get("minPrice") || null,
    max_price: formData.get("maxPrice") || null,
    min_rent_end_date: formData.get("min_rent_end_date") || null,
    max_rent_end_date: formData.get("max_rent_end_date") || null,
    owner_number: formData.get("ownerPhone") || null,
    status: formData.get("status") || null,
    ...(type !== "land" && { new_status: formData.get("new_status")}),
    deleted: deleted === true ? "true" : "false",
    is_sold: formData.get("is_sold") || null,
    in_order: formData.get("in_order") || null,
  };
  return result;
};
export const API_URL = process.env.REACT_APP_API_URL;
export const SearchData = async (asr, formData, setSearchedData, navigate,id, selectedStreets, data,allDeleted) => {
  const type = formData.get("propertyType");
  if (formData.get("id")) {
    const elid = Number(formData.get("id"));

   const fetchEstate = async (id) => {
  const response = await fetch(`${API_URL}/real-estate/${elid}`);
  const data = await response.json();
  return data;
};

const estate = await fetchEstate(id);

    if (!estate || estate.error) {
    alert("Element not found with id: " + elid);
    return "not_found";
  }

    navigate(`/${id}/${elid}`, {
    state: {
      data: estate,
      id: id,
    },
  });
    return "navigated"; // ✅ ВАЖНО
  }
  
  let sale_rent = null;
  if (asr[1]) sale_rent = "Sale";
  else if (asr[2]) sale_rent = "Rent";
  
  let deleted = false;
  if(asr[3]) deleted = true;

  try {
    let endpoint = "";
    switch (type) {
      case "house":
        endpoint = `${API_URL}/real-estate/filtred_houses`;
        break;
      case "apartment":
        endpoint = `${API_URL}/real-estate/filtred_apartments`;
        break;
      case "commercial":
        endpoint = `${API_URL}/real-estate/filtred_commercial`;
        break;
      case "land":
        endpoint = `${API_URL}/real-estate/filtred_land`;
        break;
      default:
        throw new Error("Unknown type: " + type);
    }

    const payload = createdData(formData, type, sale_rent, deleted,selectedStreets);
    console.log("Payload:", payload);
    
    const queryParams = new URLSearchParams(payload);
    
    const response = await fetch(`${endpoint}?${queryParams}`);
    if (response.ok) console.log("Fetch successful", response);
    if (!response.ok) throw new Error("Failed to fetch");

    const data = await response.json();
    console.log(data);
    setSearchedData(data);
  } catch (err) {
    console.error(err);
    setSearchedData([]);
  }
};


